import Vue from 'vue'
import VueMask from 'v-mask'
import vueCustomElement from 'vue-custom-element'
import NsAcko from './NsAcko.vue'
import Api from './api/plugin'
//import router from './router'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import 'bootstrap/dist/css/bootstrap.css'
//import store from './store/store'

Vue.component('v-select', vSelect)
Vue.use(vueCustomElement);
Vue.use(Api);
Vue.use(VueMask);
Vue.config.productionTip = false

Vue.customElement('ns-acko', NsAcko)
